import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {SystemProperties} from "../../models/system-properties";
import Helpers from "../../utils/helpers";

@Injectable()
export class SystemPropertiesControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceProperties(): Observable<SystemProperties> {
    return this.http.get(this.baseUrl + "system/properties") as Observable<SystemProperties>;
  }

  public createCServiceProperties(systemProperties: SystemProperties) {
    Helpers.trimRecursiveObj(systemProperties);
    const body = JSON.stringify(systemProperties);
    return this.http.post(this.baseUrl + "system/properties", body);
  }

  public updateServiceProperties(systemProperties: SystemProperties) {
    Helpers.trimRecursiveObj(systemProperties);
    const body = JSON.stringify(systemProperties);
    return this.http.put(this.baseUrl + "system/properties", body, { responseType: "text" });
  }

}
